import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { DialogRef } from '@rd/popup/dialog-ref';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { IconRegistryService } from '../../services/icon-registry/icon-registry.service';

@Component({
  selector: 'rd-core-auth-secure-route-dialog',
  templateUrl: './auth-secure-route-dialog.component.html',
  styleUrls: ['./auth-secure-route-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthSecureRouteDialogComponent implements OnInit {
  @HostBinding('class.rd-core-auth-secure-route-dialog') componentClass = true;

  constructor(
    protected dialogRef: DialogRef,
    protected iconRegistryService: IconRegistryService,
    public popupSettingService: PopupSettingService,
  ) {}

  ngOnInit(): void {
    this.iconRegistryService.registerIcon('close');
  }

  // Cannot inject GuardhouseService here. We have a big Circular Dependency issue
  // https://kaligo.slack.com/archives/CJRG4R5EE/p1604031922433900o
  // Warning: Circular dependency detected: libs/rd-lib/src/lib/modules/core/components/auth-secure-route-dialog/auth-secure-route-dialog.component.ts
  // -> libs/rd-lib/src/lib/modules/core/services/guardhouse/guardhouse.service.ts
  // -> libs/rd-lib/src/lib/modules/core/services/hermes/hermes.service.ts -> libs/rd-lib/src/lib/modules/popup/services/dialog/dialog.service.ts
  // -> libs/rd-lib/src/lib/modules/popup/popup-component-map.ts
  // -> libs/rd-lib/src/lib/modules/core/components/auth-secure-route-dialog/auth-secure-route-dialog.component.ts
  // To actually redirect to login URL, must whitelabel component so the circular dependency chain is broken.
  redirectToLoginUrl(): void {
    // Must override this in the whitelabelled component
    // this.guardhouseService.redirectToLoginUrl();
  }

  redirectToEnrollUrl(): void {
    // this.guardhouseService.redirectToEnrollUrl();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
